<template>
    <div>
        <div class="js-upload uk-placeholder uk-text-center">
            <span uk-icon="icon: cloud-upload"></span>
            <span class="uk-text-middle uk-text-small">Bild(er) / Datei(en) hier reinziehen oder </span>
            <div uk-form-custom>
                <input type="file" multiple>
                <span class="uk-link uk-text-small">klicken zum Hochladen</span>
            </div>
            <p class="uk-text-small uk-margin-remove uk-text-bold">max. 30 MB</p>
        </div>
        <progress id="js-progressbar" class="uk-progress" value="0" max="100" hidden></progress>
        <div class="uk-grid" v-if="fileError">
            <div class="uk-width-1-1">
                <div class="uk-text-danger">
                    Keine Bild Datei!
                </div>
            </div>
        </div>
        <div class="uk-grid" v-if="sizeError">
            <div class="uk-width-1-1">
                <div class="uk-text-danger">
                    Maximale Dateigröße überschritten!
                </div>
            </div>
        </div>
        <div class="uk-grid uk-grid-medium uk-child-width-auto" v-if="uploaded.length">
            <div v-for="(file, key) in uploaded" :key="key" v-if="isFile">
                <div>
                    <div class="uk-flex uk-padding-small uk-background-muted uk-border-rounded" style="border: 1px solid #eee">
                        <p class="uk-text-emphasis uk-margin-remove">
                            <span data-uk-icon="icon:file-pdf; ratio:1.5"></span>
                            {{ file.originFilename }}
                        </p>
                        <div class="uk-hidden-hover uk-margin-small-left">
                            <a v-if="showRemoveIcon" href="#" class="uk-text-danger" uk-icon="icon: trash;ratio: 0.8" @click.prevent="removeImage(key)"></a>
                        </div>
                    </div>
                </div>
            </div>
              <div v-for="(image, key) in images" :key="key" class="uk-inline uk-width-small uk-margin-right" v-if="isImage && images.length">
                  <div class="uk-visible-toggle">
                      <img :src="image">
                      <template v-if="showRemoveIcon">
                          <div class="uk-position-top-right uk-hidden-hover">
                              <a href="#" class="uk-text-danger" uk-icon="icon: trash" @click.prevent="removeImage(key)"></a>
                          </div>
                      </template>
                  </div>
              </div>
        </div>
    </div>
</template>
<script>

    import UIkit from 'uikit'
    import axios from 'axios'

export default {

    props: {
        url: {
            type: String,
            required: true
        },
        showRemoveIcon: {
            type: Boolean,
            required: false,
            default: true
        },
        data: {
            type: Object,
            required: false,
            default: function () { return {} }
        }
    },

    data() {
        return {
            images: [],
            uploadComplete: false,
            uploaded: [],
            fileError: false,
            sizeError: false,
            totalSize: 0,
            isImage: false,
            isFile: false,
        }
    },

    mounted() {
        let $this = this
        let bar = document.getElementById('js-progressbar');
        UIkit.upload('.js-upload', {
            url: this.url,
            maxSize: 20000,
            multiple: true,
            params: {
                data: JSON.stringify(this.data),
            },

            beforeSend: function () {
            },
            beforeAll: function (e, fileList) {
                $this.fileError = false
                $this.sizeError = false
                var reader, files = fileList;

                if(!$this.validateSize()) {
                    bar.setAttribute('hidden', 'hidden');
                    return false;
                }

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    $this.totalSize += file.size

                    if(!$this.validateSize()) {
                        $this.sizeError = true
                        bar.setAttribute('hidden', 'hidden');
                        $this.totalSize -= file.size
                        continue;
                    }

                    if (file.type.match('image')) {
                        $this.isImage = true

                        reader = new FileReader()
                        reader.onload = (e) => {
                        $this.images.push(e.target.result)
                        }
                        reader.readAsDataURL(file)
                    } else if (file.type.match('pdf')) {
                        $this.isFile = true
                    } else {
                        continue
                    }

                    /*
                    if (!file.type.match('image')) {
                        $this.fileError = true
                        continue;
                    }


                    reader = new FileReader();
                    reader.onload = (e) => {
                         $this.images.push(e.target.result);
                    };
                    reader.readAsDataURL(file);
                      */
                }
            },
            load: function () {},
            error: function () {},
            complete: function (e) {
                //console.log($this.validateSize());
                let json = JSON.parse(e.response);
                if(json !== 'FAILED') {
                    $this.uploaded.push(json);
                    $this.$emit('uploaded', json)
                }
            },
            loadStart: function (e) {
                //if(!$this.sizeError) {
                    bar.removeAttribute('hidden');
                    bar.max = e.total;
                    bar.value = e.loaded;
                //}
            },
            progress: function (e) {
                bar.max = e.total;
                bar.value = e.loaded;
            },
            loadEnd: function (e) {
                bar.max = e.total;
                bar.value = e.loaded;
            },
            completeAll: function () {
                setTimeout(function () {
                    bar.setAttribute('hidden', 'hidden');
                }, 1000);

                $this.uploadComplete = true
            }
        });
    },

    methods: {
        removeImage(index) {
            axios.post('/wp-json/ansolution/v1/forms/image/remove/' + this.uploaded[index].id).then(response => {
                this.$emit('removed', index)
                this.sizeError = false
                this.totalSize -=  this.uploaded[index].size
                this.images.splice(index, 1);
                this.uploaded.splice(index, 1);
            })
        },
     validateSize() {
        const fileSize = this.totalSize / 1024 / 1024; // in MB
        if (fileSize > 28) {
            return false
        } else {
            return true
        }
    }
    },
}
</script>
